export const CategoriasPOIActionTypes = {
  API_RESPONSE_SUCCESS: '@@categoriasPOI/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@categoriasPOI/API_RESPONSE_ERROR',

  GET_CATEGORIA_POI: '@@categoriasPOI/GET_CATEGORIA_POI',
  LIST_CATEGORIAS_POI: '@@categoriasPOI/LIST_CATEGORIAS_POI',
  ADD_CATEGORIA_POI: '@@categoriasPOI/ADD_CATEGORIA_POI',
  UPDATE_CATEGORIA_POI: '@@categoriasPOI/UPDATE_CATEGORIA_POI',
  DELETE_CATEGORIA_POI: '@@categoriasPOI/DELETE_CATEGORIA_POI',

  RESET: '@@categorias/RESET'
}
